export default {
    name: 'disputes',
    state: {},
    getters: {},
    mutations: {},
    actions: {
        createDispute: async (context, payload) => {
            return await axios.post(synergy1 + `dispute/create-dispute`,payload)
                .catch((err) => errorHandler.tomcatError(err))
        },
        fetchDispute: async (context, id) => {
            return await axios.get(synergy1 + `dispute/get-disputes/${id}`)
                .then(({data})=>data)
                .catch((err) => errorHandler.tomcatError(err))
        },
        updateDispute: async (context, {id,payload}) => {
            return await axios.post(synergy1 + `dispute/update/${id}`,payload)
                .catch((err) => errorHandler.tomcatError(err))
        },
        fetchDispatchLogs: async (context, id) => {
            return await axios.get(synergy1 + `delivery/getDispatchLogs/${id}`)
                .then(({data})=>data)
                .catch((err) => errorHandler.tomcatError(err))
        },


        // project section
        fetchProjectDispute: async (context, id) => {
            return await axios.get(synergy1 + `jobcards/get-disputes-by-project?projectID=${id}`)
                .then(({data})=>data)
                .catch((err) => errorHandler.tomcatError(err))
        },
        fetchProjectExpense: async (context, id) => {
            return await axios.get(synergy1 + `jobcards/get-expenses-by-project?projectID=${id}`)
                .then(({data})=>data)
                .catch((err) => errorHandler.tomcatError(err))
        }
    }
}
